export default __webpack_public_path__ + "static/media/bus_icon.ed6cbc5e.svg";